import { render } from 'react-dom';

const buildTree = (element: JSX.Element, ...parentsOuterFirst: JSX.Element[]) =>
  parentsOuterFirst
    .concat([element])
    .reduceRight((tree, e) => ({ ...e, ...{ props: { ...e.props, children: tree } } }));

export const renderWithParents =
  <T extends DOMStringMap>(...parents: JSX.Element[]) =>
  (containerId: string) =>
  (componentFactory: (d: T) => JSX.Element): HTMLElement | undefined => {
    const container = document.getElementById(containerId);
    if (!container) {
      // this happens when the container to mount into is not on the current page,
      // e.g. it's for a different page to what we're viewing.
      return undefined;
    }
    const element = componentFactory(container.dataset as T);
    if (element) {
      render(buildTree(element, ...parents), container);
    }
    return container;
  };
